export const dateFormats = {
  DMY: 'DD.MM.YYYY',
  ISO: 'YYYY-MM-DD',
};
export const timeFormat = 'HH:mm';
export const dateTimeFormat = `${dateFormats.DMY} с ${timeFormat}`;
